import { render, staticRenderFns } from "./DoubleAuctionMarketFutarchy.vue?vue&type=template&id=4d22f73a"
import script from "./DoubleAuctionMarketFutarchy.vue?vue&type=script&lang=js"
export * from "./DoubleAuctionMarketFutarchy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports